import type { Context } from "@/common/types/router"
import { baseRoute } from "@/common/router/baseRoutes"
import { isValidUserType } from "@/common/utils/lib"

const requireUserType = () => {
    return async ({ to, next, nextMiddleware, useUser }: Context) =>
        isValidUserType(to.meta, useUser().getUser().type)
            ? nextMiddleware()
            : next({ name: baseRoute.forbidden.name })
}

export default requireUserType
